import { createSlice } from '@reduxjs/toolkit';

export const playerSlice = createSlice({
  name: 'player',
  initialState: {
    opened: false,
    visible: false
  },
  reducers: {
    openPlayer: (state) => {
      state.opened = true;
      state.visible = true;
    },
    closePlayer: (state) => {
      state.opened = false;
      state.visible = false;
    },
    showPlayer: (state) => {
      state.visible = true;
    },
    hidePlayer: (state) => {
      state.visible = false;
    }
  }
});

export const { openPlayer, closePlayer, showPlayer, hidePlayer } = playerSlice.actions;
export default playerSlice.reducer;